import type { SVGProps } from 'react'

export const JobsOutlinedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 14H15C14.4477 14 14 14.4477 14 15V21C14 21.5523 14.4477 22 15 22H21C21.5523 22 22 21.5523 22 21V15C22 14.4477 21.5523 14 21 14ZM15 13C13.8954 13 13 13.8954 13 15V21C13 22.1046 13.8954 23 15 23H21C22.1046 23 23 22.1046 23 21V15C23 13.8954 22.1046 13 21 13H15Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 2H15C14.4477 2 14 2.44772 14 3V9C14 9.55229 14.4477 10 15 10H21C21.5523 10 22 9.55229 22 9V3C22 2.44772 21.5523 2 21 2ZM15 1C13.8954 1 13 1.89543 13 3V9C13 10.1046 13.8954 11 15 11H21C22.1046 11 23 10.1046 23 9V3C23 1.89543 22.1046 1 21 1H15Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 14H3C2.44772 14 2 14.4477 2 15V21C2 21.5523 2.44772 22 3 22H9C9.55229 22 10 21.5523 10 21V15C10 14.4477 9.55229 14 9 14ZM3 13C1.89543 13 1 13.8954 1 15V21C1 22.1046 1.89543 23 3 23H9C10.1046 23 11 22.1046 11 21V15C11 13.8954 10.1046 13 9 13H3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1.5C6.27614 1.5 6.5 1.72386 6.5 2L6.5 10C6.5 10.2761 6.27614 10.5 6 10.5C5.72386 10.5 5.5 10.2761 5.5 10L5.5 2C5.5 1.72386 5.72386 1.5 6 1.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 6C10.5 6.27614 10.2761 6.5 10 6.5L2 6.5C1.72386 6.5 1.5 6.27614 1.5 6C1.5 5.72386 1.72386 5.5 2 5.5L10 5.5C10.2761 5.5 10.5 5.72386 10.5 6Z"
      fill="currentColor"
    />
  </svg>
)
